import { store } from "../index";
import { SIZE_OF_CHANGE_STEP } from "../constants/constants";

export const isAllowLids = step => {
  const lids = store.getState().buildValuesSides[step].lids,
    height = store.getState().buildValues.height;
  for (let i = 0; i < lids.length; i++) {
    if (Math.round(lids[i].top) <= 0 ) {
      return false;
    }
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/helpers/isAllowLids.js